import styled from 'styled-components';

export const LabelContainer = styled.span<{ isOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;

  svg {
    width: 20px;
    height: 20px;
  }

  /* Not scoped to svg: the chevrons are Starfish mask icons, and they carry their own size. */
  .arrow {
    transform: rotate(${({ isOpen }) => (isOpen ? '180deg' : '0deg')});
    transition: transform 0.3s ease;
  }
`;

export const Label = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding-left: 2px;
  padding-right: 2px;
`;

export const LabelCount = styled.span``;
